// Run this code immediately without creating global variables.
(() => {
  // Measure the current header height and store it as a CSS variable.
  const updateHeaderHeight = () => {
    // Look for a sticky header first, then fall back to any header element.
    const header =
      document.querySelector('header.sticky, header[class*="sticky"]') ||
      document.querySelector('header');

    // Only update the CSS variable if a header exists on the page.
    if (header) {
      document.documentElement.style.setProperty(
        // Makes the height available in CSS as var(--header-height).
        '--header-height',

        // Get the header's actual height, including responsive changes.
        `${header.getBoundingClientRect().height}px`
      );
    }
  };

  // Set the correct header height after the page has fully loaded.
  window.addEventListener('load', updateHeaderHeight);

  // Recalculate the height whenever the browser window is resized.
  window.addEventListener('resize', updateHeaderHeight);
});


// Wait until the page HTML has finished loading.
document.addEventListener('DOMContentLoaded', function () {
  // Find every announcement message on the page or in top bar.
  const messages = document.querySelectorAll('.announcement__content');

  // Apply the click behavior to each announcement message.
  messages.forEach(function (msg) {
    // Show a pointer cursor to indicate that the message is clickable.
    msg.style.cursor = 'pointer';

    // Redirect the visitor when they click the announcement.
    msg.addEventListener('click', function (e) {
      // Prevent the click from triggering other parent elements.
      e.stopPropagation();

      // Send the visitor to the chosen collection URL.
      // Replace this path with the collection you want to link to.
      window.location.href = '/collections/';
    });
  });
});



// open external links in a new tab
document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('a');
  links.forEach(function(link) {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});



// image hover turn off zoom for product cards
(() => {
  const cardSelector = 'product-card.product-card, .product-card';
  const mediaSelector = 'img, picture, [class*="media"], [class*="image"]';

  function removeZoom(card) {
    card.querySelectorAll(mediaSelector).forEach((element) => {
      element.style.setProperty('transform', 'none', 'important');
      element.style.setProperty('scale', '1', 'important');
      element.style.setProperty('zoom', '1', 'important');
    });
  }

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest(cardSelector);
    if (card) removeZoom(card);
  });
})();



// menu desktop hover second level fix
/* Mega-menu sidebar hover intent
   Prevents brief cursor crossings from activating another submenu. */
(() => {
  const SWITCH_DELAY = 220;
  const initializedMenus = new WeakSet();

  function activateItem(menu, summary) {
    const current = menu.querySelector(
      ".menu-sidebar__toggle.is-visible"
    );

    if (current === summary) return;

    if (current) {
      current.classList.remove("is-visible");
      current.setAttribute("aria-expanded", "false");
    }

    summary.classList.add("is-visible");
    summary.setAttribute("aria-expanded", "true");

    const content = summary.nextElementSibling;
    const container = menu.closest(".mega-menu__wrapper");

    if (content && container) {
      requestAnimationFrame(() => {
        container.style.setProperty(
          "--sidebar-height",
          `${content.offsetHeight}px`
        );
      });
    }
  }

  function initializeMenu(menu) {
    if (initializedMenus.has(menu)) return;
    initializedMenus.add(menu);

    let hoverTimer = null;

    menu
      .querySelectorAll(".menu-sidebar__toggle")
      .forEach((summary) => {
        summary.addEventListener(
          "mouseenter",
          (event) => {
            /*
             Stop Pebble's immediate mouseenter handler.
             Keyboard and click events are not affected.
            */
            event.stopImmediatePropagation();
            clearTimeout(hoverTimer);

            if (summary.classList.contains("is-visible")) return;

            hoverTimer = setTimeout(() => {
              activateItem(menu, summary);
            }, SWITCH_DELAY);
          },
          true
        );

        summary.addEventListener("mouseleave", () => {
          clearTimeout(hoverTimer);
        });
      });
  }

  function initializeAllMenus(root = document) {
    root.querySelectorAll("menu-sidebar").forEach(initializeMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeAllMenus();
    });
  } else {
    initializeAllMenus();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllMenus(event.target);
  });
})();


// Decimal price superscript
(() => {
  const selector = 'product-price .price, product-price .compare-at-price';

  function styleCents() {
    document.querySelectorAll(selector).forEach((price) => {
      // Don't overwrite markup added by the theme or process a price twice.
      if (price.children.length) return;

      const match = price.textContent.trim().match(/^(.*?)([.,]\d{2})$/);
      if (!match) return;

      price.textContent = match[1];

      const cents = document.createElement('span');
      cents.className = 'price-cents';
      cents.textContent = match[2];
      price.append(cents);
    });
  }

  function start() {
    styleCents();
    new MutationObserver(styleCents).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
